import { Grid, TableContainer, Table, TableCell, styled } from '@mui/material';
import { Image } from '@mui/icons-material';

export const TableContainerMaxHeight = styled(TableContainer)(() => ({
  marginTop: '25px',
  maxHeight: '75vh'
}));

export const TableCellHeaderStickyTopAndLeft = styled(TableCell)(({ theme }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: 'large',
  whiteSpace: 'nowrap',
  left: 0,
  zIndex: 6
}));

export const TableCellHeaderStickyTop = styled(TableCell)(({ theme }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: 'large',
  whiteSpace: 'nowrap',
  zIndex: 5
}));

export const TableCellHeaderStickyTopWithWidth = styled(TableCell)(({ theme, w }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: 'large',
  whiteSpace: 'nowrap',
  zIndex: 5,
  width: `${w}%`
}));

export const TableCellHeaderStickyTopAlignedRight = styled(TableCell)(({ theme }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'right',
  fontWeight: 'bold',
  fontSize: 'large',
  whiteSpace: 'nowrap',
  zIndex: 5
}));

export const TableCellHeaderStickyTopAlignedRightWithWidth = styled(TableCell)(({ theme, w }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'right',
  fontWeight: 'bold',
  fontSize: 'large',
  whiteSpace: 'nowrap',
  zIndex: 5,
  width: `${w}%`
}));

export const TableCellHeader = styled(TableCell, { shouldForwardProp: prop => prop !== 'align' })(({ theme, align }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: align || 'left',
  fontWeight: 'bold',
  fontSize: 'large'
}));

export const TableCellHeaderWithWidth = styled(TableCell)(({ theme, w }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: 'large',
  width: `${w}%`
}));

export const TableCellWithWidth = styled(TableCell)(({ w }) => ({
  width: `${w}%`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const GridPaddedTop = styled(Grid)(() => ({
  paddingTop: '25px'
}));

export const TableMarginTop = styled(Table)(() => ({
  marginTop: '25px'
}));

export const TableFixedLayout = styled(Table)(() => ({
  tableLayout: 'fixed'
}));

export const TableCellStyledWithHeaderTextValueSmall = styled(TableCell)(({ theme }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  whiteSpace: 'nowrap',
  fontWeight: 'bold'
}));

export const TableCellStickyColumn = styled(TableCell)(() => ({
  textAlign: 'left',
  position: 'sticky',
  whiteSpace: 'nowrap',
  left: 0,
  zIndex: 1,
  minWidth: '20em',
  backgroundColor: 'white'
}));

export const TableCellStyledWithActions = styled(TableCell)(() => ({
  textAlign: 'right',
  whiteSpace: 'nowrap',
  '& div': {
    display: 'contents'
  },
  '& svg': {
    position: 'relative',
    verticalAlign: 'middle',
    width: '17px',
    height: '17px',
    margin: '0',
    padding: '0'
  }
}));

export const TableCellWithHeader = styled(TableCell)(({ theme }) => ({
  ...theme.table.tableHeader,
  backgroundColor: theme.palette.primary.main,
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: 'large'
}));

export const TableCellWithOverflow = styled(TableCell, { shouldForwardProp: prop => prop !== 'wrap' })(({ wrap }) => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  minWidth: '0',
  whiteSpace: wrap ? 'normal' : 'nowrap'
}));

export const HasImageIcon = styled(Image)(() => ({
  fontSize: 20,
  color: 'DimGray',
  margin: '0 0 0.2rem 0.5rem',
  verticalAlign: 'middle'
}));
